import React, { useEffect, useState } from "react";
import NavBar from "components/SideBar/SideBar2";
import { ToastContainer } from "react-toastify";
import "./style.css";
import { RingLoader } from "react-spinners";
import { useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
  InputAdornment,
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import SearchIcon from "@material-ui/icons/Search";

import { CustomTextField } from "../utility";
import { displayValue } from "utils/randomKey";
const Table31 = (props) => {
  const rowStyle2 = (row, rowIndex) => {
    const style = {};
    style.backgroundColor = "#fff";
    return style;
  };
  const [search, setSearch] = useState("");
  const loaderStatus = useSelector(
    (store) => store.gstr8PrepareDataReducer.loaderStatus
  );
  const Table31Columns = [
     {
      dataField: "gstin",
      text: "GSTIN of ECO",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "16%",
      },
      
    },
    {
      dataField: "eid",
      text: "Enrolment no. of supplier",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "20%",
      },
      
    },
    {
      dataField: "LN",
      text: "Name of Supplier",

      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center"; 
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "16%",
      },
    },

    {
      dataField: "grossValSup",
      text: "Gross value of supplies made",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "16%",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.grossValSup != null && row.grossValSup != undefined)?displayValue(row.grossValSup):"--"}
          </>
        )
      }
      //   formatter: (cell, row) => {
      //     return (
      //       <div
      //         style={{ width: "100%" }}
      //         onClick={row.total != "0" ? () => downloadFile(row, "total") : ""}
      //       >
      //         {row.total}
      //       </div>
      //     );
      //   },
    },

    {
      dataField: "valSup",
      text: "Value of supplies returned",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "16%",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.valSup != null && row.valSup != undefined)?displayValue(row.valSup):"--"}
          </>
        )
      }
      //   formatter: (cell, row) => {
      //     return (
      //       <div
      //         style={{ width: "100%" }}
      //         onClick={row.pass != "0" ? () => downloadFile(row, "pass") : ""}
      //       >
      //         {row.pass}
      //       </div>
      //     );
      //   },
    },
    {
      dataField: "netAmtSup",
      text: "Net value of Supplies",
      style: (cell, row, rowIndex, colIndex) => {
        const fontFamily = "Gt-Walsheim-medium";
        const fontSize = "11px";
        const fontWeight = "bold";
        const textAlign = "center";
        return { fontFamily, fontSize, fontWeight, textAlign };
      },
      headerStyle: {
        fontFamily: "Gt-Walsheim-medium",
        fontSize: "12px",
        fontWeight: "bold",
        verticalAlign: "text-top",
        width: "16%",
      },
      formatter:(col, row)=>{
        return (
          <>
          {(row.netAmtSup != null && row.netAmtSup != undefined)?displayValue(row.netAmtSup):"--"}
          </>
        )
      }
    },
  ];
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex" }}>
          <Button
            onClick={() => {
              props.setShowViewTab(false);
            }}
            variant="outlined"
            color="primary"
            startIcon={<ArrowBackIosIcon />}
            style={{
              //   backgroundColor: "#4f2d7f",
              color: "#4f2d7f",
              height: "30px",
              textTransform: "capitalize",
              marginTop: "4px",
            }}
          >
            Back
          </Button>{" "}
          <div className="span-text">{props.supType}</div>
        </div>
        <div style={{ display: "flex" }}>
          <div className="search-custom">
            <CustomTextField
              placeholder="Search"
              onChange={(e) => setSearch(e.target.value)}
              value={search}
              variant="outlined"
              size="small"
              // onChange={handleInputChange}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.getViewTableData(props.supType, search)}
            style={{
              backgroundColor: "#4f2d7f",
              color: "white",
              height: "30px",
              marginTop: "4px",
              padding: "0em 2em",
              textTransform: "capitalize",
            }}
          >
            Search
          </Button>
        </div>
      </div>
      {props.viewTabData?.length > 0 ? (
        <>
          <div style={{ marginTop: "1em" }}>
            <div>
              <BootstrapTable
                keyField="gstin"
                // data={[
                //   {
                //     id: "1",
                //     GSTN: "ABC456789012345",
                //     a: "12345",
                //     b: "09876",
                //   },
                // ]}
                data={props.viewTabData}
                // columns={column2}
                columns={Table31Columns}
                rowStyle={rowStyle2}
                // selectRow={props.selectRow}
              />
            </div>
          </div>
        </>
      ) : (
        <div
          style={{
            height: "40vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography style={{ fontWeight: "800" }}>
            No Data Available
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Table31;
